export enum VdpCardType {
  Favorite = 'favorites',
  Recent = 'viewed',
  Suggested = 'suggested',
  None = 'none'
}
